<template>
  <div>
    <div
      v-if="!checkupStore.isOptimizationLoading && portfolio"
      :class="[
        'tw-flex tw-cursor-pointer tw-justify-between tw-items-center tw-rounded-lg tw-py-2 tw-px-4 tw-font-poppins tw-font-medium tw-text-sm',
        { 'tw-bg-white tw-text-[#1F2229]': checked }
      ]"
      @click="toggle"
    >
      <div class="tw-flex tw-items-center tw-gap-2">
        <i
          :class="{
            'fas fa-check-circle': checked,
            'far fa-circle tw-color-white tw-opacity-50': !checked,
          }"
          :style="{ color: checked ? color : '' }"
        />
        {{ portfolio.name }}
      </div>
      <div>
        <i
          class="fas fa-circle tw-hidden"
          :style="{ color }"
        />
      </div>
    </div>
    <div v-else>
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-2 tw-px-4 tw-font-poppins tw-font-medium tw-text-sm tw-text-gray-400">
        <div class="tw-flex tw-items-center tw-gap-2">
          <!-- <AdvisorCoreCheckbox :is-active="false" /> -->
          <span>Optimization in progress</span>
        </div>
        <div class="tw-w-full tw-h-1 tw-bg-gray-400 tw-relative tw-overflow-hidden">
          <div class="tw-indeterminate-progress-bar" />
        </div>
        <div class="tw-text-xs">
          Optimizations may take up to 30 minutes to complete
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvisorCoreCheckbox from '@frontend/ui/components/utils/AdvisorCoreCheckbox.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  components: {
    AdvisorCoreCheckbox,
  },
  props: {
    portfolio: {
      type: Object,
      required: false,
    },
    color: {
      type: String,
      default: '#EEEFF2',
    },
  },
  data() {
    return {
      checked: true,
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
  },
  methods: {
    toggle() {
      this.checked = !this.checked;
      // this.$emit('onChecked', this.checked);
      setTimeout(() => this.$emit('onChecked', this.checked), 0);
    },
  },
};
</script>

<style scoped>
.tw-indeterminate-progress-bar {
  @apply tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-bg-gray-500;
  width: 30%;
  animation: indeterminate 1.5s infinite linear;
}

@keyframes indeterminate {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}
</style>
